import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { createStyleHelper } from '../../../shared/utils/class-names';

import styles from './sessions-table.module.scss';

const style = createStyleHelper(styles, 'sessions-table');

export interface ISessionsTableProps {
    sessions: Array<{
        id?: string | null;
        type?: string | null;
    }>;
}

export const SessionsTable: FunctionComponent<ISessionsTableProps> = ({ sessions }) => {
    return (
        <table className={style()}>
            <thead>
                <tr className={style('headings')}>
                    <th className={style('heading')}>
                        <FormattedMessage
                            id="sessions.table.session-id"
                            defaultMessage="Session ID"
                        />
                    </th>
                    <th className={style('heading')}>
                        <FormattedMessage id="sessions.table.type" defaultMessage="Type" />
                    </th>
                </tr>
            </thead>
            <tbody>
                {sessions.map((session) => (
                    <tr key={session.id} className={style('row')}>
                        <td className={style('item')}>{session.id}</td>
                        <td className={style('item')}>{session.type}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
